import { components } from 'react-select';
import { LOCALES } from 'utils/languageUtils';

const CountriesSingleValueTemplate = (props) => (
  <components.SingleValue {...props}>
    <div className="county-option">
      {props.data?.image && <img className="county-flag" alt="" src={props.data?.image} />}
      <span className="county-name">
        {props.selectProps?.language === LOCALES.ENGLISH ? props.data?.en : props.data?.el}
      </span>
    </div>
  </components.SingleValue>
);
export default CountriesSingleValueTemplate;
